module.exports = __webpack_public_path__ + "static/media/han-taste-ad6.390fd3df.png";